//librerias
import { Component, ViewChild } from "@angular/core";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import {
  colorProcessAsistenciaGbuIntegradaRef,
  colorProcessAsistenciaIntegradaSifcaRef,
  colorProcessRef,
  colorProcessRpaRef,
  ProcessIdByName,
} from "src/app/calendar/constants/ProcessId";
import { ERpaProcessStatus } from "src/app/calendar/interfaces/tipo-sesion";
import { CalendarService } from "src/app/calendar/services/tipoSesion/calendar.service";
import { GeneralEmptyModalComponent } from "src/app/shared/modals/general-empty-modal/general-empty-modal.component";
import { ModalConfig } from "src/app/shared/modals/modal.interfaces";

interface ColorProcess {
  processId: ProcessIdByName | ERpaProcessStatus;
  statusType: "rpa" | "crud";
  color: string;
  label: string;
}
@Component({
  selector: "app-calendar-main-page",
  templateUrl: "./calendar-main-page.component.html",
  styleUrls: ["./calendar-main-page.component.css"],
})
export class CalendarMainPageComponent {
  public renderModal: boolean = false;
  constructor(
    private authLocalService: AuthenticationService,
    private calendarService: CalendarService
  ) {}
  @ViewChild("modalNewSession")
  private modalComponent!: GeneralEmptyModalComponent;

  public modalConfig: ModalConfig = {
    modalTitle: "Nueva Sesion",
    hideDismissButton: true,
    hideCloseButton: true,
    ngModalOptions: {
      centered: true,
      size: "lg",
      backdrop: "static",
    },
  };
  public labelColorDesc: ColorProcess[] = [
    {
      processId: ProcessIdByName.create,
      color: colorProcessRef[ProcessIdByName.create],
      label: "Creado",
      statusType: "crud",
    },
    {
      processId: ProcessIdByName.update,
      color: colorProcessRef[ProcessIdByName.update],
      label: "Actualizado",
      statusType: "crud",
    },
    {
      processId: ERpaProcessStatus.fail,
      color: colorProcessRpaRef[ERpaProcessStatus.fail],
      label: "Error al registrar en GB University",
      statusType: "rpa",
    },
    {
      processId: ERpaProcessStatus.pending,
      color: colorProcessRpaRef[ERpaProcessStatus.pending],
      label: "Procesando cambios a GB University",
      statusType: "rpa",
    },
    {
      processId: ERpaProcessStatus.success,
      color: colorProcessAsistenciaIntegradaSifcaRef.get(true)!,
      label: "Asistencias Registradas",
      statusType: "rpa",
    },
    {
      processId: ERpaProcessStatus.success,
      color: colorProcessAsistenciaGbuIntegradaRef.get(true)!,
      label: "Asistencias enviadas",
      statusType: "rpa",
    },
  ];
  addSession() {
    this.renderModal = true;
    this.modalComponent.open().then(() => {
      const u = this.authLocalService.currentUserValue;
      this.calendarService.getSessionsById(u.id.toString() ?? "");
      this.renderModal = false;
    });
  }
  async closeModal(close: boolean) {
    await this.modalComponent.close();
  }
}
